module.exports = __webpack_public_path__ + "img/banner2.4937c4fa.png";